import { PlusOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Space, Badge, Table } from 'antd'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { CTAButton } from '../../components'
import NewAuthAccount from './new'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    content: {
        padding: theme.spacing(3, 0)
    },
    table: {
        maxWidth: '100%',
        width: '100%'
    }
}))

/**
 * Admin page to manage auth accounts from different providers
 */
const AuthAccounts = (props) => {
    const [accounts, setAccounts] = useState([])
    const [show, setShow] = useState(false)

    const classes = useStyles()
    const data = useData()
    const users = data.users()

    const newAccount = () => setShow(true)

    const accountsSchema = [
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id'
        },
        {
            title: 'Username',
            key: 'username',
            dataIndex: 'user_name'
        },
        {
            title: 'Provider',
            key: 'provider',
            dataIndex: 'provider'
        },
        {
            title: 'Date created',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (date) => moment(date).format("YYYY-MM-DD HH:mm")
        },
        {
            title: 'Active',
            key: 'active',
            dataIndex: 'active',
            render: (active) => <Badge status={active ? 'success' : 'error'} />
        }
    ]

    const loadAccounts = () => {
        trackPromise(users.loadAuthAccounts()
            .then(a => {
                console.log(a)
                setAccounts(a)
            })
            .catch(console.log))
    }

    // load the accounts
    useEffect(() => {
        loadAccounts()
    }, [])

    const {promiseInProgress} = usePromiseTracker()

    const closeDrawer = () => {
        setShow(false)
        loadAccounts()
    }

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <h1>Auth Acccounts</h1>
                <CTAButton onClick={newAccount}>
                    <Space>
                        <PlusOutlined />
                        Add an account
                    </Space>
                </CTAButton>
            </div>

            <div className={classes.content}>
                <Table
                    columns={accountsSchema}
                    className={classes.table}
                    loading={promiseInProgress}
                    dataSource={accounts}
                />
            </div>

            <NewAuthAccount visible={show} close={closeDrawer} />
        </div>
    )
}

export default AuthAccounts